export default "__VITE_ASSET__BgLdFBpF__"